import Vue from 'vue'

Vue.filter('firstLetter', function(value) {
  return (value || '')
    .trim()
    .charAt(0)
    .toUpperCase()
})
